"use strict";

exports.__esModule = true;
exports.DataItemValueWidget = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _DataItemValueElement = require("./DataItemValueElement");
var _DataItemValueFields = require("./DataItemValueFields");
var _DataItemValueHeader = require("./DataItemValueHeader");
var _DataItemValueThumbnail = require("./DataItemValueThumbnail");
var _widgetGroups = require("../widgetGroups");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var DataItemValueWidget = exports.DataItemValueWidget = {
  name: "DataItemValue",
  label: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "DataItemValueWidget.label",
    defaultMessage: "MTC Value"
  }),
  icon: "feed",
  group: _widgetGroups.RAW_DATA_WIDGET,
  createElement: function createElement(props) {
    return {
      type: "DataItemValue",
      props: Object.assign({
        width: 128,
        height: 64,
        dataItemName: "XM1act",
        timestampType: "timestamp"
      }, props),
      children: []
    };
  },
  showInPalette: true,
  isParent: false,
  requiresContexts: ["device"],
  suppliesContexts: [],
  optionalProps: ["fontFamily", "fontSize", "fontWeight", "fontStyle", "textDecoration", "textAlignment", "color", "backgroundColor", "backgroundColorSource"],
  requiresProps: ["x", "y", "width", "height", "dataItemName"],
  suppliesProps: [],
  propConstraints: {
    width: {
      "default": 128,
      min: 32,
      max: 3840
    },
    height: {
      "default": 64,
      min: 32,
      max: 2160
    }
  },
  components: {
    Header: _DataItemValueHeader.DataItemValueHeader,
    Element: _DataItemValueElement.DataItemValueElement,
    Fields: _DataItemValueFields.DataItemValueFields,
    Thumbnail: _DataItemValueThumbnail.DataItemValueThumbnail
  }
};